<template>
  <form @submit.prevent="$emit('submit')">
    <string-form-field
      :label="$t('creditAssignmentRequest.fields.title')"
      :value="value.title"
      :error="findError('title')"
      @input="propertyChange('title', $event)"
    />

    <!--
    <credit-assignment-request-status-form-field
      input-id
      output-id
      multiple
      :dropdown="false"
      :label="$t('file.fields.status')"
      :value="value.statusId"
      :error="findError('statusId')"
      @input="propertyChange('statusId', $event)"
    />
    -->

    <!--
    Il pulsante nascosto permette di sottomettere il form alla pressione
    del tasto INVIO in uno dei campi contenuti; altrimenti l'invio del
    form non avviene.
    -->
    <b-button type="submit" class="d-none"></b-button>
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
//import CreditAssignmentRequestStatusFormField from "@/modules/creditassignment/requeststatus/protected/CreditAssignmentRequestStatusFormField";

export default {
  mixins: [EditorMixin]

  /*
  components: {
    CreditAssignmentRequestStatusFormField
  }
  */
};
</script>
